import { getActionTypes } from '../../../HelperMethods/UtilityFunctions';

const types = getActionTypes('instructionManagement')([
  'SET_LOADER',
  'LOAD_INSTRUCTIONS',
  'UPSERT_INSTRUCTION',
  'DELETE_INSTRUCTION',
  'SET_FORM_LOADER',
]);

export function loadInstruction(instructions) {
  return { type: types.LOAD_INSTRUCTIONS, instructions };
}

export function setLoader(loader) {
  return { type: types.SET_LOADER, loader };
}

export function setFormLoader(loader) {
  return { type: types.SET_FORM_LOADER, loader };
}

export function upsertInstruction(instruction) {
  return { type: types.UPSERT_INSTRUCTION, instruction };
}

export function deleteInstruction(instruction) {
  return { type: types.DELETE_INSTRUCTION, instructionId: instruction.id };
}

export default function instructionReducer(
  state = { isInstructionPageLoading: true, instructions: [], isInstructionFormLoading: false },
  action
) {
  switch (action.type) {
    case types.SET_LOADER: {
      return { ...state, isInstructionPageLoading: action.loader };
    }
    case types.SET_FORM_LOADER: {
      return { ...state, isInstructionFormLoading: action.loader };
    }
    case types.LOAD_INSTRUCTIONS: {
      return { ...state, instructions: action.instructions };
    }
    case types.DELETE_INSTRUCTION: {
      return {
        ...state,
        instructions: state.instructions.filter(({ id: instructionId }) => instructionId !== action.instructionId),
      };
    }
    case types.UPSERT_INSTRUCTION: {
      const { instruction } = action;
      return {
        ...state,
        instructions: [
          ...state.instructions.filter(({ id: instructionId }) => instructionId !== instruction.id),
          instruction,
        ],
      };
    }
    default:
      return state;
  }
}
